import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { TabPanel, TabView } from "primereact/tabview";
import { Badge, Card, Table } from "react-bootstrap";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Editor } from "primereact/editor";
import {
  CustomOutlinedDisabledTextField,
  CustomOutlinedDisabledCurrencyField,
} from "../../../../partials/content/Forms";
import NumberFormat from "react-number-format";
import Illustration from "../../../../partials/content/Illustration";
import {
  getAccountingJournalDetail,
  reverseAccountingJournal,
} from "../../../../services/finance/accountingJournal";
import { formatDate } from "../../../../utils/utils";
import { Typography } from "@material-ui/core";

function JournalEntryDetail({ journalID = 0, onReserveSave }) {
  const [accountingHead, setAccountingHead] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const getAccountingJournalDetailData = async (journalID = 0) => {
    const response = await getAccountingJournalDetail(journalID);
    const { data } = response.data;
    setAccountingHead(data.accountingHead);
  };

  useEffect(() => {
    if (journalID > 0) {
      getAccountingJournalDetailData(journalID);
    }
  }, [journalID]);

  const handleReverseAccountingJournal = (journalID = 0) => {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title:
          "Are you sure want to reverse this Accounting Journal Document ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, reverse it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          reverseAccountingJournal(journalID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Reversed",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            onReserveSave();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };
  return (
    <React.Fragment>
      {accountingHead !== null ? (
        <React.Fragment>
          <div className="tabview mb-3">
            <div className="card">
              <TabView className="tabview" scrollable>
                <TabPanel
                  header="Journal Entry Main"
                  rightIcon="fas fa-th-large"
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Card>
                        <Card.Header>
                          <i className="fas fa-window-maximize"></i>
                          <span>
                            <strong>Journal Entry Header</strong>
                          </span>
                          <Badge
                            className="float-right ml-1"
                            variant={
                              accountingHead.docType === 1
                                ? "primary"
                                : accountingHead.docType === 2
                                ? "success"
                                : accountingHead.docType === 3
                                ? "danger"
                                : accountingHead.docType === 4
                                ? "info"
                                : null
                            }
                          >
                            {accountingHead.docType !== 0
                              ? accountingHead.docTypeDesc
                              : null}
                          </Badge>
                        </Card.Header>
                        <Card.Body>
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Document Date"
                                value={formatDate(accountingHead.documentDate)}
                              />
                              <CustomOutlinedDisabledTextField
                                label="Currency"
                                value={accountingHead.currency.currencyCode}
                              />
                              <div className="row">
                                <div className="col-sm-6 col-md-6 col-lg-6">
                                  <CustomOutlinedDisabledTextField
                                    label="Doc Ref"
                                    value={accountingHead.docRef}
                                  />
                                </div>
                                <div className="col-sm-6 col-md-6 col-lg-6">
                                  <CustomOutlinedDisabledTextField
                                    label="Doc Ref ID"
                                    value={accountingHead.docRefID}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <CustomOutlinedDisabledCurrencyField
                                label="Amount"
                                value={accountingHead.totalAmount}
                              />
                              <CustomOutlinedDisabledTextField
                                label="Exchange Rate To Base Currency"
                                value={accountingHead.exchangeRate}
                              />
                              {accountingHead.revJournalID > 0 ? (
                                <CustomOutlinedDisabledTextField
                                  label="Reversal Journal ID"
                                  value={accountingHead.revJournalID}
                                />
                              ) : null}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                              {accountingHead.docType === 1 ? (
                                <button
                                  type="button"
                                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                                  onClick={() => {
                                    handleReverseAccountingJournal(journalID);
                                  }}
                                >
                                  <i className="fas fa-undo-alt"></i>
                                  Reverse Journal
                                </button>
                              ) : null}
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel header={"Note"} rightIcon="fas fa-sticky-note">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <Card>
                        <Card.Header>
                          <i className="fas fa-sticky-note"></i>
                          <span>
                            <strong>Note</strong>
                          </span>
                        </Card.Header>
                        <Card.Body>
                          <Editor
                            style={{ height: "200px", width: "100%" }}
                            value={accountingHead.note}
                            placeholder="Type your notes here..."
                            readOnly={true}
                            className="editor-grey"
                          />
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </TabPanel>
              </TabView>
            </div>
          </div>
          <div className="accordion">
            <div className="card">
              <Accordion
                className="accordion"
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                <AccordionTab
                  header={
                    <React.Fragment>
                      <i className="fas fa-sitemap"></i>
                      <span>
                        <strong>Journal Items</strong>
                      </span>
                    </React.Fragment>
                  }
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="card">
                            <Table striped borderless size="sm" responsive="xl">
                              {accountingHead.accountingItems &&
                              accountingHead.accountingItems.length > 0 ? (
                                <thead>
                                  <tr>
                                    <th style={{ width: "25%" }}>
                                      <Typography className="mx-1 kt-font-bolder">
                                        Account
                                      </Typography>
                                    </th>
                                    <th style={{ width: "10%" }}>
                                      <Typography className="mx-1 kt-font-bolder">
                                        D/C Indicator
                                      </Typography>
                                    </th>
                                    <th style={{ width: "15%" }}>
                                      <Typography className="mx-1 kt-font-bolder float-right">
                                        Debit
                                      </Typography>
                                    </th>
                                    <th style={{ width: "15%" }}>
                                      <Typography className="mx-1 kt-font-bolder float-right">
                                        Credit
                                      </Typography>
                                    </th>
                                    <th style={{ width: "35%" }}>
                                      <Typography className="mx-1 kt-font-bolder">
                                        Note
                                      </Typography>
                                    </th>
                                  </tr>
                                </thead>
                              ) : null}
                              <tbody>
                                {accountingHead.accountingItems &&
                                accountingHead.accountingItems.length > 0 ? (
                                  accountingHead.accountingItems.map(
                                    (item, index) => {
                                      return (
                                        <tr key={index}>
                                          <td>
                                            <Typography className="mx-1 my-1">
                                              {item.glAccount.accountName}
                                            </Typography>
                                          </td>
                                          <td>
                                            <Typography className="mx-1 my-1">
                                              {item.dbInd === "D"
                                                ? "Debit"
                                                : "Credit"}
                                            </Typography>
                                          </td>
                                          <td>
                                            {item.dbInd === "D" ? (
                                              <Typography
                                                component="div"
                                                className="mx-1 my-1"
                                              >
                                                <NumberFormat
                                                  value={item.amount}
                                                  displayType={"text"}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  renderText={(value) => (
                                                    <div className="float-right">
                                                      {value}
                                                    </div>
                                                  )}
                                                />
                                              </Typography>
                                            ) : null}
                                          </td>
                                          <td>
                                            {item.dbInd === "C" ? (
                                              <Typography
                                                component="div"
                                                className="mx-1 my-1"
                                              >
                                                <NumberFormat
                                                  value={item.amount}
                                                  displayType={"text"}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  renderText={(value) => (
                                                    <div className="float-right">
                                                      {value}
                                                    </div>
                                                  )}
                                                />
                                              </Typography>
                                            ) : null}
                                          </td>
                                          <td>
                                            <Typography className="mx-1 my-1">
                                              {item.note}
                                            </Typography>
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      className="text-center py-3"
                                      colSpan="5"
                                    >
                                      <Illustration
                                        imageSource="INVIFO Payment.png"
                                        guidance="You don't have any Journal items yet"
                                        guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                        size="sm"
                                      ></Illustration>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                              {accountingHead.accountingItems &&
                              accountingHead.accountingItems.length > 0 ? (
                                <tfoot>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td>
                                      <Typography
                                        component="div"
                                        className="mx-1 my-1 kt-font-bolder"
                                      >
                                        <NumberFormat
                                          value={accountingHead.totalAmount}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                          renderText={(value) => (
                                            <div className="float-right">
                                              {value}
                                            </div>
                                          )}
                                        />
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography
                                        component="div"
                                        className="mx-1 my-1 kt-font-bolder"
                                      >
                                        <NumberFormat
                                          value={accountingHead.totalAmount}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                          renderText={(value) => (
                                            <div className="float-right">
                                              {value}
                                            </div>
                                          )}
                                        />
                                      </Typography>
                                    </td>
                                    <td></td>
                                  </tr>
                                </tfoot>
                              ) : null}
                            </Table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
}

export default JournalEntryDetail;
